import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import HomeScreen from './screens/HomeScreen';
import VillaNajatScreen from './screens/VillaNajatScreen';
import VillaNadiaScreen from './screens/VillaNadiaScreen';
import OurVillasScreen from './screens/OurVillasScreen';
import ServicesScreen from './screens/ServicesScreen';
import GalleryScreen from './screens/GalleryScreen';
import ContactScreen from './screens/ContactScreen';
import ReviewsScreen from './screens/ReviewsScreen';
import BookingScreen from './screens/BookingScreen';
import BookingSuccessScreen from './screens/BookingSuccessScreen';
import ProfileScreen from './screens/ProfileScreen';
import AboutScreen from './screens/AboutScreen';
import GastronomyScreen from './screens/GastronomyScreen';
import PrivacyPolicyScreen from './screens/PrivacyPolicyScreen';
import TermsOfServiceScreen from './screens/TermsOfServiceScreen';
import NotFoundScreen from './screens/NotFoundScreen';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import './i18n';
import './App.css';

// Layout wrapper component
const LayoutWrapper = () => {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <ScrollToTop />
          <Layout>
            <Outlet />
          </Layout>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};

// Create router configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutWrapper />,
    children: [
      { index: true, element: <HomeScreen /> },
      { path: "about", element: <AboutScreen /> },
      { path: "our-villas", element: <OurVillasScreen /> },
      { path: "villa-najat", element: <VillaNajatScreen /> },
      { path: "villa-nadia", element: <VillaNadiaScreen /> },
      { path: "booking", element: <BookingScreen /> },
      { path: "booking-success", element: <BookingSuccessScreen /> },
      { path: "profile", element: <ProfileScreen /> },
      { path: "services", element: <ServicesScreen /> },
      { path: "gastronomy", element: <GastronomyScreen /> },
      { path: "reviews", element: <ReviewsScreen /> },
      { path: "gallery", element: <GalleryScreen /> },
      { path: "contact", element: <ContactScreen /> },
      { path: "privacy", element: <PrivacyPolicyScreen /> },
      { path: "terms", element: <TermsOfServiceScreen /> },
      { path: "*", element: <NotFoundScreen /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
